import React from 'react';
export function Commitment() {
  return <section className="bg-parchment py-24" data-id="element-67" data-mp="hfb7biutukai">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-68" data-mp="1w4i6kbrz3vr5">
        <p className="eyebrow text-green-dark" data-id="element-69" data-mp="1w2xb8jxu48s8">Our Commitment</p>
        <blockquote className="mt-8" data-id="element-70" data-mp="2131s4b2nn5iz">
          <p className="font-display text-[26px] font-medium italic leading-[1.4] text-ink sm:text-[32px]" data-id="element-71" data-mp="21206xdrxd2nj">
            &ldquo;We hold trust and consistency as core values. Clients rely on us
            to observe ethical standards and professional due care in every
            engagement — and to deliver the same standard of work every time we are
            called on.&rdquo;
          </p>
        </blockquote>
        <div className="mx-auto mt-10 w-16 border-t border-ink/25" aria-hidden="true" data-id="element-72" data-mp="2otp2d301m78p" />
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.14em] text-ink-50" data-id="element-73" data-mp="2orbbz7gb5j7h">
          Trust &amp; Consistency — Core Values, Premier Advisory Services Ltd
        </p>
      </div>
    </section>;
}